import React, {Component} from 'react';
import {Segment, List, Dropdown, Menu} from "semantic-ui-react";

export default class Trends extends Component {

    render() {

        const options = [
            { key: 1, text: 'Investment', value: 1, selected: true },
            { key: 2, text: 'Groceries', value: 2 },
            { key: 3, text: 'Utilities', value: 3 },
        ];

        return (
            <Segment.Group className='hooli-segment'>
                <Segment className='hooli-segment-top'>
                    <List>
                        <List.Item>
                            <List.Content floated='right'>
                                <Menu compact>
                                    <Dropdown placeholder='Category' options={options} simple item className='hooli-dropdown-blue'/>
                                </Menu>
                            </List.Content>
                            <List.Header><h3 className='hooli-text-dark-blue'>TRENDS</h3></List.Header>
                        </List.Item>
                    </List>
                </Segment>
                <Segment className='hooli-segment-bottom'/>
            </Segment.Group>
        )

    }


}
